module.exports = __webpack_public_path__ + "static/media/new_cool.c2ec8ddd.jpg";